import ModalHeading from 'components/atoms/teachers/ModalHeading';
import ModalText from 'components/atoms/teachers/ModalText';
import React from 'react';
import styled from '@emotion/styled';
export default (props) => {
    const { heading, isError, text, textAlign = 'center' } = props;
    return (React.createElement(TextContainer, null,
        React.createElement(ModalHeading, { isError: isError, text: heading }),
        text ? React.createElement(ModalText, { text: text, textAlign: textAlign }) : null));
};
const TextContainer = styled.div `
  margin: 0 30px 80px;
  white-space: pre-wrap;
`;
